import { useState, useCallback } from 'react';
import { FilterState } from '../DealsFilters.types';
import { createInitialFilterState } from '../DealsFilters.utils';


export const useDealsFilters = () => {
  const [filterState, setFilterState] = useState<FilterState>(createInitialFilterState());

  const updateFilter = useCallback((updates: Partial<FilterState>) => {
    setFilterState((prev) => {
      const newState: FilterState = {
        dealHealth: updates.dealHealth !== undefined ? updates.dealHealth : prev.dealHealth,
        owner: updates.owner !== undefined ? updates.owner : prev.owner,
        client: updates.client !== undefined ? updates.client : prev.client,
        startDate: updates.startDate !== undefined ? updates.startDate : prev.startDate,
        closeDate: updates.closeDate !== undefined ? updates.closeDate : prev.closeDate,
      };
      
      return newState;
    });
  }, []);

  const clearAllFilters = useCallback(() => {
    setFilterState(createInitialFilterState());
  }, []);

  return {
    filterState,
    updateFilter,
    clearAllFilters,
  };
};
